import PassengerType from "@CheckOrder/types/Passenger.type";

/**
 * In requests where we return passengers from BE our passengers data is cleared on check order form.
 *
 * If for some reason someone triggers request without fully updating passenger data,
 * passengers data is overwritten (cleared) inside form. This helps users to not have to enter the data which they already entered.
 */
export default function consolidatePassengers(oldPassengersList: PassengerType[], newPassengersList: PassengerType[]) {
    const consolidatePassenger = (currentFEPassengerData: PassengerType, newPassengerData: PassengerType): PassengerType => ({
        ...newPassengerData,
        passengerFirstName: !!newPassengerData.passengerFirstName ? newPassengerData.passengerFirstName : currentFEPassengerData.passengerFirstName,
        passengerLastName: !!newPassengerData.passengerLastName ? newPassengerData.passengerLastName : currentFEPassengerData.passengerLastName,
        additionalInfo: newPassengerData.additionalInfo && currentFEPassengerData.additionalInfo,
        returnAdditionalInfo: newPassengerData.returnAdditionalInfo && currentFEPassengerData.returnAdditionalInfo,
    })

    const getOldPassengerData = (newPassengerData: PassengerType): PassengerType => (
        oldPassengersList.find((currentPassenger) => (
            currentPassenger.passengerId === newPassengerData.passengerId
        ))
    )

    return newPassengersList.map((newPassengerData) => (
        consolidatePassenger(getOldPassengerData(newPassengerData) ?? newPassengerData, newPassengerData)
    ))
}